import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import Fade from '@mui/material/Fade'
import { styled } from '@mui/material/styles'

const customArrowPosition = (placement: string | undefined) => {
    if (placement === 'top-end') {
        return {
            left: '-30px !important',
        }
    } else if (placement === 'top-start') {
        return {
            left: '30px !important',
        }
    } else {
        return {}
    }
}
const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        slots={{
            transition: Fade,
        }}
    />
))(({ theme, placement }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        color: 'rgba(0, 0, 0, 0.87)',
        borderRadius: 4,
        fontSize: '16px',
        fontWeight: 300,
        backgroundColor: '#ffffff',
        padding: '12px 16px 12px 16px',
        boxShadow: '0px 0px 24px #00000034;',
        right: placement === 'top-end' ? '-35px' : 'auto',
        left: placement === 'top-start' ? '-35px' : 'auto',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
        ...customArrowPosition(placement),
        '&::before': {
            backgroundColor: '#f7f7f7',
            border: '1px solid #999',
        },
    },
}))
export default CustomTooltip
